import { getSickleHeaders } from '../utils/getHeaders';
import { sickleApi } from '../modules/aggregator/pages/api';

const handleGetRefreshToken = async (refreshToken) => {
  const response = await sickleApi.get(
    '/nodeapi/scd/sickle-refresh-token',
    {
      headers: {
        accessToken: refreshToken,
      },
    }
  );
  // console.log("Refresh Token Response: ", response.data.data.result.token);
  localStorage.setItem('sickle_token', response.data.data.result.token);
  localStorage.setItem('health_facility_id', response.data.data.result.facility_id);
  return response.data;
};

const sickleRequest = async (endpoint, data = {}, method = 'post') => {
  await handleGetRefreshToken(localStorage.getItem('sickle_refresh_token'));

  if (method.toLowerCase() === 'get') {
    return sickleApi.get(endpoint, { headers: getSickleHeaders(), params: data });
  }

  return sickleApi[method](endpoint, data, { headers: getSickleHeaders() });
};

export const sickleAPI = {
  getState: async () => (await sickleRequest('/nodeapi/scd/state', {}, 'get')).data,
  getDistrict: async (data) => (await sickleRequest('/nodeapi/scd/district', data)).data,
  getBlock: async (data) => (await sickleRequest('/nodeapi/scd/block', data)).data,
  getUrban: async (data) => (await sickleRequest('/nodeapi/scd/urban', data)).data,
  getVillage: async (data) => (await sickleRequest('/nodeapi/scd/village', data)).data,
  getFacility: async (data) => (await sickleRequest('/nodeapi/scd/sickle-get-facility', data)).data,
  getHealthIdMapping: async (abhaNumber) => (await sickleRequest('/nodeapi/scd/sickle-search-beneficiery', { abha_id: abhaNumber })).data,
  registerBeneficiary: async (data) => (await sickleRequest('/nodeapi/scd/sickle-patient-registration', data)).data,
  savePatientTestDetails: async (data) => (await sickleRequest('/sickle2staging/Patient_Data', data)).data,
  searchBeneficiary: async (mobileNumber) => (await sickleRequest('/nodeapi/scd/sickle-search-beneficiery', { MobileNo: mobileNumber })).data,
  getRegistrationDetails: async (data) => (await sickleRequest('/sickle2staging/Sickle_data/PatientRegistrationDetails', data)).data,
  getDiseasedBeneficiaries: async (data) => (await sickleRequest('/sickle2staging/V1/treatment/diseased_beneficiaries', data)).data,
  getBloodGroups: async () => (await sickleRequest('/nodeapi/scd/blood-groups', {}, 'get')).data,
  getMedicalHistory: async (data) => (await sickleRequest('/sickle2staging/V1/medical_history/show', data)).data,
  createTreatmentInstance: async (data) => (await sickleRequest('/sickle2staging/V1/treatment/treatment_beneficiaries', data)).data,
  viewMedicalHistoryRecord: async (data) => (await sickleRequest('/sickle2staging/V1/medical_history/detail', data)).data,
  createMedicine: async (data) => (await sickleRequest('/sickle2staging/V1/medicine/create', data)).data,
  showMedicine: async (data) => (await sickleRequest('/sickle2staging/V1/medicine/show/', data)).data,
  deleteMedicine: async (data) => (await sickleRequest('/sickle2staging/V1/medicine/delete', data)).data,
  getLabTests: async () => (await sickleRequest('/sickle2staging/treatment2/treatment_master/lab_investication', {}, 'get')).data,
  getLabTestResults: async (testId) => (await sickleRequest('/sickle2staging/treatment2/Treatment_master/labtestresult', { test_id: testId })).data,
  createLabInvestigation: async (data) => (await sickleRequest('/sickle2staging/V1/labinvestigation/create', data)).data,
  showLabInvestigation: async (data) => (await sickleRequest('/sickle2staging/V1/labinvestigation/show/', data)).data,
  deleteLabInvestigation: async (data) => (await sickleRequest('/sickle2staging/V1/labinvestigation/delete', data)).data,
  createBloodTransfusion: async (data) => (await sickleRequest('/sickle2staging/V1/bloodtransfusion/create', data)).data,
  getBloodTransfusion: async (data) => (await sickleRequest('/sickle2staging/V1/bloodtransfusion/show/', data)).data,
  deleteBloodTransfusion: async (data) => (await sickleRequest('/sickle2staging/V1/labinvestigation/delete', data)).data,
  getVaccineDose: async (vaccineId) => (await sickleRequest('/sickle2staging/treatment2/Treatment_master/dose', { vaccine_id: vaccineId })).data,
  getVaccine: async (data) => (await sickleRequest('/sickle2staging/V1/immunization/show/', data)).data,
  deleteVaccine: async (data) => (await sickleRequest('/sickle2staging/V1/immunization/delete', data)).data,
  getVaccineNames: async () => (await sickleRequest('/sickle2staging/treatment2/treatment_master/vaccine', {}, 'get')).data,
  getDrugList: async (diseaseId) => (await sickleRequest(`/sickle2staging/treatment2/treatment_master/drug?disease_code=${diseaseId}`, {}, 'get')).data,
  createVaccine: async (data) => (await sickleRequest('/sickle2staging/V1/immunization/create', data)).data,
};